import { useCallback } from 'react'

import { FormChangedHandler, useFormData } from 'brief-form'

import { FormPaths } from '../../enums'
import { useSyncFormData } from '../../hooks'
import { useValidateFormPersist } from '../../hooks/useValidateFormPersist'
import { ContactDetailsChangeHandler, ContactDetailsFormData, ContactDetailsFormValue } from '../../types/forms'

export const useContactDetailsForm = ({
  contactIndex,
  companyIndex,
  formData,
  onChange
}: {
  contactIndex: number
  companyIndex: number
  formData: ContactDetailsFormData
  onChange: ContactDetailsChangeHandler
}) => {
  const onFormChanged: FormChangedHandler<ContactDetailsFormValue> = useCallback(
    (formValues, formErrors) => onChange({ companyIndex, formData: { formValues, formErrors }, contactIndex }),
    [onChange, contactIndex, companyIndex]
  )

  const { config, Field, set, validate } = useFormData<ContactDetailsFormValue>({
    onFormChanged,
    initialValue: formData.formValues,
    initialErrors: formData.formErrors
  })

  useSyncFormData({ set, formData })
  const formKey = `${FormPaths.CONTACT_DETAILS}-${companyIndex}-${contactIndex}`
  useValidateFormPersist<ContactDetailsFormValue>({
    formName: formKey,
    validate,
    config
  })

  return { Field, config }
}
